import { Injectable, NgZone } from '@angular/core';
import { SignalRService } from './signalr.service';

@Injectable()
export class SignalREventService {
    private registrations: Object[][] = [];

    constructor(
        private _signalRService: SignalRService,
        private _ngZone: NgZone
    ) {

    }

    public registerAdvanced(registeringService: any, event: string, callback: any): void {
        const service: string = registeringService.constructor.name;
        this.register(service, event, callback);
    }

    public register(service: string, event: string, callback: any): void {
        const innerCallback = (...msg: any[]) => {
            this._ngZone.run(() => callback(...msg));
        };

        if (!this.registrations[service]) {
            this.registrations[service] = {};
        }

        if (!this.registrations[service].hasOwnProperty(event)) {
            this.registrations[service][event] = innerCallback;

            this._signalRService.on(event, innerCallback);
        }
    }

    public deregister(service: string): void {
        for (const reg in this.registrations[service]) {
            if (this.registrations[service][reg] != null) {
                this._signalRService.off(reg, this.registrations[service][reg]);
            }
        }

        delete this.registrations[service];
    }

    public deregisterOnServerEvents(): void {
        for (const service in this.registrations) {
            this.deregister(service.toString());
        }
    }
}
